import { render } from "./PremiumBills.vue?vue&type=template&id=555225c8&scoped=true"
import script from "./PremiumBills.vue?vue&type=script&lang=js"
export * from "./PremiumBills.vue?vue&type=script&lang=js"

import "./PremiumBills.vue?vue&type=style&index=0&id=555225c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555225c8"]])

export default __exports__